import React from 'react'
import {Form} from 'react-bootstrap'

// Single-choice dropdown for the compact layout — the space-saving
// equivalent of ToggleInput. Options may be individually disabled (e.g. the
// "coming soon" toric flow), which a native <select> handles for free.
export default function CompactSelect({label, VS, setVS, placeholder, options}) {
    return (
        <div className='inputDiv'>
            <span className='controlLabel iolx-label'
            style={{display: (label === '')? 'none' : null}}>{label}</span>
            <Form.Select
            className='formControl controlValid'
            value={VS[0]}
            onChange={(e) => setVS([e.target.value, 1])}>
                {(placeholder)?
                    <option value='' disabled>{placeholder}</option>
                : null}
                {options.map((option) =>
                    <option key={option.value} value={option.value} disabled={option.disabled}>
                        {option.label}{(option.disabled)? ' (coming soon)' : ''}
                    </option>
                )}
            </Form.Select>
        </div>
    )
}
